<template>
  <div>
    <ModalConfirmAction
      :title="title"
      :message="confirmMessage"
      :loading="loading"
      @confirm="handleClick"
      @cancel="() => {}"
    >
      <template #activator="{ on, attrs }">
        <v-tooltip left color="surface_neutral_selected">
        <template v-slot:activator="{ on: tooltipOn, attrs: tooltipAttrs }">
          <div class="card-action-box card-action-box--delete" v-bind="{ ...attrs, ...tooltipAttrs }" v-on="{ ...on, ...tooltipOn }" role="button" aria-label="Excluir">
          <v-icon>mdi-card-remove</v-icon>
        </div>
        </template>
        <span>Excluir</span>
      </v-tooltip>
      </template>
    </ModalConfirmAction>
  </div>
</template>

<script>
import { apiClient } from "@/services/api";
import { mapActions, mapGetters } from "vuex";
import ModalConfirmAction from "@/components/Modal/ModalConfirmAction.vue";

export default {
  components: { ModalConfirmAction },
  props: {
    colaboracao: Object,
    noticia: Object,
    enquete: Object
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    ...mapGetters({
      cod_pasta: 'pastas/getterCodPasta'
    }),
    title() {
      if (this.noticia) return 'Remover notícia da pasta';
      if (this.colaboracao) return 'Remover colaboração da pasta';
      return 'Remover enquete da pasta';
    },
    confirmMessage() {
      if (this.noticia) return 'Tem certeza que deseja remover a notícia da pasta?';
      if (this.colaboracao) return 'Tem certeza que deseja remover a colaboração da pasta?';
      return 'Tem certeza que deseja remover a enquete da pasta?';
    },
  },
  methods: {
    ...mapActions({
      getColaboracoesAprovadas:
        "colaboracoes_aprovadas/getColaboracoesAprovadas",
      setCopyColaboracoesRecebidas: "colaboracoes_aprovadas/setCopyColaboracoesRecebidas",
      getNoticiasAprovadas: "noticias/getNoticiasAprovadas",
      getEnquetesProducao: "enquetes/getEnquetesProducao"
    }),
    async handleClick() {
      if(this.colaboracao) {
          this.removerColaboracao();
          return;
      } else if(this.noticia) {
        this.removerNoticia();
        return
      }
      this.removerEnquete();
    },
    async removerEnquete() {
      try {
        this.loading = true;
        const response = await apiClient.delete(`/pastas/excluirEnquetePasta/${this.cod_pasta}/${this.enquete.id}`);
        if(response.status === 200) {
          await this.getEnquetesProducao({
            cod_producao: this.$store.state.producoes.selectedProducao.cod_producao,
            filtro_texto: this.$store.state.enquetes.filtroEnquetes,
            flg_favorita: this.flg_favorita,
            size: 5,
            cod_pasta: this.cod_pasta,
            page: this.$store.state.enquetes.enquetesProducao.currentPage
          });
        }
      }catch(error) {
        console.error(error);
        this.$toast.error("Erro ao remover enquete da pasta")
      }finally{
        this.loading = false;
      }
  },
  async removerNoticia() {
      try {
          this.loading = true;

          const response = await apiClient.delete(`/pastas/excluirNoticiaPasta/${this.cod_pasta}/${this.noticia.cod_noticia}`);
          if(response.status === 200) {
              await this.getNoticiasAprovadas({
                  cod_portal: this.$store.state.portais.selectedPortal.cod_portal,
                  cod_producao: this.$store.state.producoes.selectedProducao.cod_producao,
                  flg_favorita: this.$store.state.noticias.flg_favorita,
                  page: this.$store.state.noticias.noticiasAprovadas.currentPage,
                  size: this.size,
                  filtro_texto: this.$store.state.noticias.filtro_aprovadas,
                  cod_pasta: this.cod_pasta
              })
              this.$toast.success("Noticia removida com sucesso");
              return;
          }
      }catch(error) {
          console.error(error);
          this.$toast.error("Erro ao remover noticia da pasta")
      }finally{
          this.loading = false;
      }
    },
    async removerColaboracao() {
      try {
        this.loading = true;

        const flg_favorita = JSON.parse(localStorage.getItem("@socialcam/flg_favorita")) || false
        const flg_exibida = JSON.parse(localStorage.getItem("@socialcam/flg_exibida")) || false

        const response = await apiClient.delete(
          `/pastas/excluirColaboracaoPasta/${this.cod_pasta}/${this.colaboracao.id_colaboracao}`
        );

        const page = flg_exibida ? this.$store.state.colaboracoes_aprovadas.colaboracoes.colaboracoes_exibidas.currentPage
                      : flg_favorita ? this.$store.state.colaboracoes_aprovadas.colaboracoes.colaboracoes_favoritas.currentPage
                      : this.$store.state.colaboracoes_aprovadas.colaboracoes.colaboracoes_recebidas.currentPage
        if (response.status === 200) {
          await this.getColaboracoesAprovadas({
            page,
            size: 5,
            cod_producao: JSON.parse(
              localStorage.getItem("@socialcam/selected_option_production")
            ),
            flg_favorita:
              JSON.parse(localStorage.getItem("@socialcam/flg_favorita")) ||
              false,
            filtros:
              JSON.parse(localStorage.getItem("@socialcam/filtros")) || [],
            filtro_texto: localStorage.getItem("@socialcam/filtro_texto") || "",
            flg_exibida,
            cod_pasta: this.cod_pasta
          });
          this.setCopyColaboracoesRecebidas(this.$store.state.colaboracoes_aprovadas.colaboracoes.colaboracoes_recebidas)
          this.$toast.success("Colaboração removida com sucesso");
          return;
        }
      } catch (error) {
        console.error(error);
        this.$toast.error("Não foi possível remover a colaboração da pasta.");
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.deleteButton1 {
  background: var(--v-surface_neutral_selected-base) !important;
}
</style>
